import React, { useState, useEffect } from 'react';
import { ProgressCircular } from '@/components/custom/progress';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Widget, WidgetBody, WidgetCount, WidgetHeader, WidgetHeaderContent, WidgetTitle } from '@/components/custom/widget';

export function ExamsQuestionsClock(props) {
  const { t } = useTranslation();
  const { questionBooksUser, questionBook, setElapsedTime, examTime } = props;
  const [clock, setClock] = useState();
  const [percentageTime, setPercentageTime] = useState();
  let intervalId = null;

  useEffect(() => {
    tick();
    if (intervalId !== null) {
      clearInterval(intervalId);
    }
    intervalId = setInterval(() => tick(), 1000);
  }, []);

  const tick = () => {
    if (questionBook && questionBooksUser) {
      const createdAt = questionBooksUser.created_at;
      const resolutionTime = moment(`1970-01-01 ${questionBook['resolution-time']}`);
      const newClock = resolutionTime.subtract(moment().diff(createdAt, 'seconds'), 'second');

      const durationSeconds = moment(questionBook['resolution-time'], 'HH:mm').diff(moment().startOf('day'), 'seconds');
      const passedSeconds = moment().diff(createdAt, 'seconds');
      const percentage = ((durationSeconds - passedSeconds) * 100) / durationSeconds;

      if (percentage <= 0) {
        clearInterval(intervalId);
      } else {
        setPercentageTime(100 - percentage);
        setClock(newClock);
        setElapsedTime(passedSeconds);
      }
    }
  };

  return (
    <Widget className="mb-2">
      <WidgetHeader>
        <WidgetHeaderContent>
          <WidgetTitle>{t('exams.time')}</WidgetTitle>
          <WidgetCount>
            <span>{!examTime ? 'Sem tempo definido!' : examTime + 'h'}</span>
          </WidgetCount>
        </WidgetHeaderContent>
      </WidgetHeader>

      <WidgetBody className="flex justify-center">
        {clock && (
          <ProgressCircular
            time={clock.format('H:mm:ss')}
            valueNow={percentageTime}
          />
        )}
      </WidgetBody>
    </Widget>
  );
}
